var map = {
	"./add.svg": "b3c0",
	"./delete.svg": "571d",
	"./edit.svg": "2dd2",
	"./emoji.svg": "6118",
	"./error.svg": "ec4e",
	"./exit-fullscreen.svg": "792d",
	"./fullscreen.svg": "cc7c",
	"./lock.svg": "3b18",
	"./money.svg": "4f35",
	"./order.svg": "51b5",
	"./permission.svg": "1cc0",
	"./quit.svg": "c85d",
	"./save.svg": "bc10",
	"./user.svg": "4d66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";